<app-menu></app-menu>
<div class="container-fluid mt-5">
    <div class="col-12">
        <div class="row">
            <div class="col-6">
                <h3>
                    <img src="../../../assets/img/clientes.png" width="70"> Listado de Clientes:
                </h3>
            </div>
            <div class="col-6">
                <div class="form-group mt-3">
                    <select class="form-control sch" (click)="filtrar($event.target.value)">
                        <option value="" selected>Seleccione para búsqueda...</option>
                        <option value="distribuidores">Distribuidores</option>
                        <option value="clientes">Clientes</option>  
                        <option value="todos">Todos</option>                    
                    </select>
                </div>
            </div>
        </div>
    </div>
    <hr>
    <div class="mt-2">
        <div class="table-responsive">
            <table style="font-size: 13px;" class="table table-hover">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Email</th>
                        <th scope="col">Cédula/Nit</th>
                        <th scope="col">Teléfono</th>
                        <th scope="col">Registro</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Descto</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of lista">
                        <th>{{item.nombre}}</th>
                        <td>{{item.email}}</td>
                        <td>{{item.cedula}}</td>
                        <td>{{item.telefono}}</td>
                        <td>{{item.fechaCreacion | date}}</td>
                        <td>{{item.tipo}}</td>
                        <td *ngIf="item.estado == 'Activo' && item.tipo == 'Distribuidor'"><b>{{item.descuento | number}}%</b></td>
                        <td *ngIf="item.estado != 'Activo' && item.tipo == 'Cliente'"><b> - </b></td>
                        <td *ngIf="item.estado != 'Activo' && item.tipo == 'Distribuidor'"><b> - </b></td>

                        <td>
                            <div *ngIf="item.tipo == 'Distribuidor'">
                                <button *ngIf="item.estado == 'Activo'" class="btn btn-danger btn-sm mr-1" (click)="desactivar(item.id)" title="Desactivar cliente"><i class="fa fa-ban"></i></button>
                                <button *ngIf="item.estado == 'Pendiente'" class="btn btn-primary btn-sm" (click)="activar(item.id)" title="activar cliente"><i class="fa fa-check"></i></button>
                                <button *ngIf="item.estado == 'Activo'" class="btn btn-success ml-1 btn-sm" title="Descuento" (click)="dist(item.id)" data-toggle="modal" data-target="#descuento"><i class="fa fa-percent"></i></button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- Modal Descuento-->
<div class="modal fade" id="descuento" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Indique el porcentaje de descuento para el proveedor:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">%</span>
                    </div>
                    <input type="text" class="form-control" placeholder="Ingrese el %" [(ngModel)]="descuentoPorcent">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-dark" (click)="descuentoDistribuidor()" data-dismiss="modal">Asignar descuento</button>
            </div>
        </div>
    </div>
</div>